import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../../App";
import { Link } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight } from "react-icons/fi";
import HeaderTitle from "../HederTitle/HeaderTitle";

const NewArrival = () => {
  const [collections, setCollections] = useState([]);

  useEffect(() => { fetchCollections(); }, []);

  const fetchCollections = async () => {
    try {
      const res = await axios.get(`${backend_url}/api/newArrivals`);
      setCollections(res.data);
    } catch (e) { console.error(e); }
  };

  const ordered = collections.length >= 2
    ? [collections[1], collections[0], ...collections.slice(2)]
    : collections;
  const hero = ordered[0];
  const rest  = ordered.slice(1, 4);

  return (
    <section className="relative overflow-hidden py-16 px-6 sm:px-12 lg:px-20 bg-white">

      {/* Ambient blobs */}
      <div className="absolute -top-32 right-0 w-96 h-96 rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(circle,#EEE5FA,transparent)" }} />
      <div className="absolute bottom-0 -left-20 w-80 h-80 rounded-full blur-3xl opacity-15 pointer-events-none"
        style={{ background: "radial-gradient(circle,#F6F1FE,transparent)" }} />

      {/* Ghost watermark */}
      <p className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-black whitespace-nowrap pointer-events-none select-none"
        style={{
          fontSize: "clamp(80px,18vw,220px)",
          color: "transparent",
          WebkitTextStroke: "1px rgba(124,58,237,0.05)",
          letterSpacing: "-0.04em",
        }}>
        ARRIVALS
      </p>

      <div className="relative max-w-7xl mx-auto">

        {/* Header — shared style */}
        <div className="mb-10">
          <HeaderTitle Header="New Arrivals" />
        </div>

        {/* Editorial split: hero left + 3 landscape cards right */}
        <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_0.88fr] gap-5">

          {/* ── Hero card ── */}
          {hero && (
            <Link
              to={`collections/${hero.routeTo}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group block"
            >
              <div
                className="relative rounded-3xl overflow-hidden h-[460px] sm:h-[560px] lg:h-[640px] transition-all duration-500"
                style={{ boxShadow: "0 6px 32px rgba(0,0,0,0.16)" }}
                onMouseEnter={e => {
                  e.currentTarget.style.boxShadow =
                    "0 0 0 3px rgba(168,85,247,0.60), 0 28px 64px rgba(124,58,237,0.28)";
                  e.currentTarget.style.transform = "translateY(-7px)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.boxShadow = "0 6px 32px rgba(0,0,0,0.16)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {/* Image */}
                <img
                  crossOrigin="anonymous"
                  src={hero.image}
                  alt={hero.collectionName}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />

                {/* Dark gradient */}
                <div className="absolute inset-0 pointer-events-none"
                  style={{ background: "linear-gradient(to top, rgba(15,10,10,0.85) 0%, rgba(15,10,10,0.22) 50%, transparent 74%)" }} />

                {/* Subtle hover tint */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{ background: "linear-gradient(to top, rgba(15,10,10,0.35) 0%, transparent 60%)" }} />

                {/* NEW badge */}
                <div className="absolute top-5 left-5 z-10">
                  <span className="inline-flex items-center gap-1.5 text-white text-[10px] font-black
                                   px-3 py-1.5 rounded-full tracking-widest shadow-lg"
                    style={{ background: "linear-gradient(90deg,#8353C6,#9E79D2)" }}>
                    ✦ NEW ARRIVAL
                  </span>
                </div>

                {/* Bottom content */}
                <div className="absolute bottom-0 left-0 right-0 p-7 z-10">
                  <div className="w-10 h-[2px] mb-4 rounded-full" style={{ background: "#9E79D2" }} />
                  <h3 className="text-white font-black leading-tight mb-2"
                    style={{ fontSize: "clamp(22px,2.8vw,32px)" }}>
                    {hero.collectionName}
                  </h3>
                  <p className="text-white/50 text-sm mb-5 tracking-wide">
                    Exclusive handcrafted collection
                  </p>

                  <div className="opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0
                                  transition-all duration-350">
                    <span className="inline-flex items-center gap-2 text-white text-sm font-bold
                                     px-5 py-2.5 rounded-full"
                      style={{ background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.28)" }}>
                      Shop Collection <FiArrowUpRight size={14} />
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          )}

          {/* ── 3 landscape side cards ── */}
          <div className="flex flex-col gap-4 lg:h-[640px]">
            {rest.map((item) => (
              <Link
                key={item._id}
                to={`collections/${item.routeTo}`}
                onClick={() => window.scrollTo(0, 0)}
                className="group block flex-1"
              >
                <div
                  className="relative rounded-2xl overflow-hidden w-full h-full min-h-[130px] transition-all duration-400"
                  style={{ boxShadow: "0 3px 18px rgba(0,0,0,0.12)" }}
                  onMouseEnter={e => {
                    e.currentTarget.style.boxShadow =
                      "0 0 0 2.5px rgba(168,85,247,0.55), 0 14px 40px rgba(124,58,237,0.22)";
                    e.currentTarget.style.transform = "translateX(6px)";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.boxShadow = "0 3px 18px rgba(0,0,0,0.12)";
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  {/* Image */}
                  <img
                    crossOrigin="anonymous"
                    src={item.image}
                    alt={item.collectionName}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-600 ease-out"
                  />

                  {/* Gradient — heavier on left where text sits */}
                  <div className="absolute inset-0 pointer-events-none"
                    style={{ background: "linear-gradient(100deg, rgba(15,10,10,0.80) 0%, rgba(15,10,10,0.45) 42%, rgba(15,10,10,0.08) 70%, transparent 100%)" }} />

                  {/* Subtle hover tint */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-400 pointer-events-none"
                    style={{ background: "linear-gradient(100deg, rgba(15,10,10,0.25) 0%, transparent 60%)" }} />

                  {/* Left-aligned text */}
                  <div className="absolute inset-0 flex flex-col justify-center pl-6 pr-28 z-10">
                    <p className="text-[9px] font-bold tracking-[0.28em] uppercase mb-1.5"
                      style={{ color: "#D6C3F0" }}>
                      New Arrival
                    </p>
                    <h4 className="text-white font-bold text-sm sm:text-[15px] leading-snug">
                      {item.collectionName}
                    </h4>
                    <div className="mt-2 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0
                                    transition-all duration-300">
                      <span className="inline-flex items-center gap-1 text-[11px] font-semibold"
                        style={{ color: "#D6C3F0" }}>
                        Explore <FiArrowRight size={10} />
                      </span>
                    </div>
                  </div>

                  {/* NEW chip — top right */}
                  <div className="absolute top-3 right-3 z-10">
                    <span className="text-white text-[8px] font-black px-2.5 py-[5px] rounded-full shadow"
                      style={{ background: "linear-gradient(90deg,#8353C6,#9E79D2)" }}>
                      NEW
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom divider */}
        <div className="mt-12 flex items-center gap-4">
          <div className="flex-1 h-px"
            style={{ background: "linear-gradient(to right,rgba(124,58,237,0.3),transparent)" }} />
          <span className="text-purple-300 text-[10px] font-bold tracking-[0.3em] uppercase">
            {collections.length} Collections
          </span>
          <div className="flex-1 h-px"
            style={{ background: "linear-gradient(to left,rgba(124,58,237,0.3),transparent)" }} />
        </div>
      </div>
    </section>
  );
};

export default NewArrival;
